module.exports = __webpack_public_path__ + "img/cpic.7b8a2eef.png";